// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"FieldLabel-primaryButton-3DOi6d","fieldLabel":"FieldLabel-fieldLabel-3crw3L","required":"FieldLabel-required-eCZxuN"};